module.exports = __webpack_public_path__ + "static/media/arrow-right.93bab7c5.svg";